import React from 'react';
import UserNavbar from './UserNavbar';
function ExpendedHeader() {
  return (
    <UserNavbar />
  );
}

export default ExpendedHeader;
